// useMask.ts
type MaskPattern = string | string[] | undefined;

// helpers
const onlyNumbers = (v: string) => v.replace(/\D/g, "");
const onlyLetters = (v: string) => v.replace(/[^a-zA-Z]/g, "").toUpperCase();
const onlyAlphaNumeric = (v: string) =>
  v.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

// Crie sua mascara de forma simples:
// A para Letras, minusculas e maiúsculas
// 0 para numeros
// * para alfanumericos

// ex: 'AAA-0*00' para placas de veículos
// ex: '(00) 00000-0000' para celular
// ex ['(00) 0000-0000', '(00) 00000-0000'] para telefone fixo e celular. obs: a primeira mascara tem preferencia sob a segunda

export default function useMask(mask: MaskPattern) {
  return (value: string) => {
    if (!mask) return value;

    const masks = Array.isArray(mask) ? mask : [mask];
    let formattedValue = "";

    for (const m of masks) {
      const clean = getCleanValue(value, m);
      const masked = applyMask(clean, m);

      if (masked.length > formattedValue.length) {
        formattedValue = masked;
      }
    }

    return formattedValue;
  };
}

function applyMask(value: string, mask: string) {
  let result = "";
  let valueIndex = 0;

  for (let i = 0; i < mask.length; i++) {
    const maskChar = mask[i];
    const currentChar = value[valueIndex];

    if (!currentChar) break;

    switch (maskChar) {
      case "0": // números
        if (/\d/.test(currentChar)) {
          result += currentChar;
          valueIndex++;
        } else {
          valueIndex++;
          i--;
        }
        break;

      case "A": // letras
        if (/[a-zA-Z]/.test(currentChar)) {
          result += currentChar.toUpperCase();
          valueIndex++;
        } else {
          valueIndex++;
          i--;
        }
        break;

      case "*": // alfanumérico
        if (/[a-zA-Z0-9]/.test(currentChar)) {
          result += currentChar.toUpperCase();
          valueIndex++;
        } else {
          valueIndex++;
          i--;
        }
        break;

      default: // caracteres fixos da máscara
        result += maskChar;
        if (currentChar === maskChar) {
          valueIndex++;
        }
        break;
    }
  }

  return result;
}

function getCleanValue(value: string, mask: string) {
  if (mask.includes("A") && mask.includes("0")) {
    return onlyAlphaNumeric(value);
  }

  if (mask.includes("A")) return onlyLetters(value);
  return onlyNumbers(value);
}
